import { buildUrl } from "../../utils/url"

export const makeLinkApiEndpoints = (linkId = ":linkId") => {
  return {
    links: (params?: URLSearchParams) => buildUrl("/links", params),
    linkItem: (id = linkId) => `/links/${id}`,
  }
}
